import { render, staticRenderFns } from "./TestSection.vue?vue&type=template&id=6282b4ac&scoped=true&"
import script from "./TestSection.vue?vue&type=script&lang=js&"
export * from "./TestSection.vue?vue&type=script&lang=js&"
import style0 from "./TestSection.vue?vue&type=style&index=0&id=6282b4ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282b4ac",
  null
  
)

export default component.exports